import React, { useState, useEffect } from "react";
import styled from "styled-components";
import "./Scrolltotop.css";
import { Scroll } from "../Scroll function/scroll";
import { FaArrowUp } from "react-icons/fa";

function ScrolltoTop() {
  const [top, setTop] = useState(true);

  useEffect(() => {
    const mybutton = document.getElementById("myBtn");
    window.onscroll = function () {
      scrollFunction();
      // console.log("af")
    };
    function scrollFunction() {
      if (
        document.body.scrollTop > 20 ||
        document.documentElement.scrollTop > 20
      ) {
        mybutton.style.display = "block";
      } else {
        mybutton.style.display = "none";
      }
    }
  }, [top]);

 

  return (
    <button
      id="myBtn"
      className="Scrolltotop"
      onClick={() => {
        Scroll();
      }}
    >
      <FaArrowUp />
    </button>
  );
}

export default ScrolltoTop;
